export default __webpack_public_path__ + "static/media/Cancer.28c273fd.svg";